/* More Bees Please: product page helpers (delivery nudge, sticky mobile bar, pairs-well-with add buttons). */
(function () {
  if (window.mbpProductInit) return;
  window.mbpProductInit = true;

  var formatGBP = function (pence) {
    var v = pence / 100;
    return '£' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  };

  /* ---------- Free delivery nudge ("You're £X away") ---------- */
  function updateDelivery() {
    var strips = document.querySelectorAll('[data-mbp-delivery]');
    if (!strips.length) return;
    fetch((window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart') + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        strips.forEach(function (strip) {
          var away = strip.querySelector('[data-mbp-away]');
          if (!away) return;
          var threshold = parseInt(strip.dataset.threshold, 10) || 4000;
          if (cart.currency !== 'GBP' || !cart.item_count) { away.hidden = true; return; }
          // Count only items that need delivery (e.g. emailed experience vouchers do not).
          // Falls back to the basket total if the cart JSON has no per-item requires_shipping.
          var items = cart.items || [];
          var hasFlag = items.length && items.every(function (i) { return typeof i.requires_shipping === 'boolean'; });
          var shippable = cart.total_price;
          if (hasFlag) {
            shippable = 0;
            items.forEach(function (i) {
              if (i.requires_shipping) shippable += (typeof i.final_line_price === 'number' ? i.final_line_price : i.line_price) || 0;
            });
            if (!shippable) { away.hidden = true; return; }
          }
          var diff = threshold - shippable;
          away.textContent = diff > 0 ? ' · You’re ' + formatGBP(diff) + ' away' : ' · Your basket qualifies';
          away.hidden = false;
        });
      })
      .catch(function () {});
  }
  document.addEventListener('mbp:cart-updated', function () { setTimeout(updateDelivery, 300); });
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) {
      setTimeout(updateDelivery, 1500);
    }
  }, true);

  /* ---------- Sticky mobile add-to-basket bar ---------- */
  function initSticky(bar) {
    var section = bar.dataset.section;
    var form = document.getElementById('product-form-' + section);
    var mainBtn = form ? form.querySelector('[name="add"]') : document.querySelector('[data-mbp-enquire]');
    var target = mainBtn || document.getElementById('ProductInfo-' + section);
    if (!target) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var outOfView = false;

    var setVisible = function () {
      var show = mq.matches && outOfView;
      bar.hidden = !show;
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('mbp-sticky-on', show);
    };
    var passed = function (entry) {
      // only show after the button has scrolled above the viewport (not before reaching it)
      return !entry.isIntersecting && entry.boundingClientRect.top < 0;
    };
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { outOfView = passed(entry); });
      setVisible();
    }).observe(target);
    if (mq.addEventListener) mq.addEventListener('change', setVisible);

    var add = bar.querySelector('[data-mbp-sticky-add]');
    if (add && mainBtn) {
      add.addEventListener('click', function () { mainBtn.click(); });
      // mirror disabled / label state of the real button
      new MutationObserver(function () {
        add.disabled = mainBtn.hasAttribute('disabled');
        var label = mainBtn.querySelector('span');
        if (label) add.textContent = label.textContent.trim();
      }).observe(mainBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    }
    var price = document.getElementById('price-' + section);
    var stickyPrice = bar.querySelector('[data-mbp-sticky-price]');
    if (price && stickyPrice) {
      var sync = function () {
        var p = price.querySelector('.price-item--sale') || price.querySelector('.price-item--regular');
        if (p && p.textContent.trim()) stickyPrice.textContent = p.textContent.trim();
      };
      new MutationObserver(sync).observe(price, { childList: true, subtree: true });
      sync();
    }
  }

  /* ---------- Pairs well with: "+ Add" buttons ---------- */
  function initPairs(root) {
    root.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches('[data-mbp-pair-form]')) return;
      e.preventDefault();
      var btn = form.querySelector('button');
      var original = btn.innerHTML;
      btn.disabled = true;
      var body = { items: [{ id: parseInt(form.querySelector('[name="id"]').value, 10), quantity: 1 }], sections: 'cart-icon-bubble' };
      fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) throw new Error(res.description || 'Error');
          btn.textContent = 'Added ✓';
          if (res.sections && res.sections['cart-icon-bubble']) {
            var bubble = document.getElementById('cart-icon-bubble');
            var html = new DOMParser().parseFromString(res.sections['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
            if (bubble && html) bubble.innerHTML = html.innerHTML;
          }
          document.dispatchEvent(new CustomEvent('mbp:cart-updated'));
          setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 2500);
        })
        .catch(function () { btn.innerHTML = original; btn.disabled = false; form.submit(); });
    });

    // Upgrade to Search & Discovery complementary products when configured
    var url = root.dataset.complementaryUrl;
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (text) {
      var doc = new DOMParser().parseFromString(text, 'text/html');
      var fresh = doc.querySelector('[data-mbp-pairs-list]');
      var list = root.querySelector('[data-mbp-pairs-list]');
      if (fresh && fresh.children.length && list) { list.innerHTML = fresh.innerHTML; root.hidden = false; root.dataset.source = 'complementary'; }
    }).catch(function () {});
  }

  // Strip the " GBP" currency code that the Subscriptions app block prints next to prices
  function stripGbp(root) {
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var n; while ((n = w.nextNode())) { if (/\d\s*GBP/.test(n.nodeValue)) n.nodeValue = n.nodeValue.replace(/(\d)\s*GBP\b/g, '$1'); }
  }
  function initGbp() {
    document.querySelectorAll('.product__info-container, [data-mbp-sticky]').forEach(function (el) {
      stripGbp(el);
      if (window.MutationObserver) new MutationObserver(function () { stripGbp(el); }).observe(el, { childList: true, subtree: true, characterData: true });
    });
  }

  function init() {
    initGbp();
    updateDelivery();
    document.querySelectorAll('[data-mbp-sticky]').forEach(initSticky);
    document.querySelectorAll('[data-mbp-pairs]').forEach(initPairs);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
